import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { endpoints } from '../services/api';

export default function Dashboard() {
    const [stats, setStats] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        endpoints.expedientes.list({ limit: 5 }).then(r => {
            const data = r.data;
            setStats({
                total: data.length,
                abiertos: data.filter(e => e.estado === 'abierto').length,
                en_proceso: data.filter(e => e.estado === 'en_proceso').length,
                completados: data.filter(e => e.estado === 'completado').length,
                recientes: data.slice(0, 5),
            });
        }).catch(() => {});
    }, []);

    return (
        <div>
            <h1 style={{ marginTop: 0 }}>Dashboard</h1>

            {stats && (
                <>
                    <div className="grid-4" style={{ marginBottom: '24px' }}>
                        <div className="stat-card">
                            <div className="stat-value">{stats.total}</div>
                            <div className="stat-label">Total expedientes</div>
                        </div>
                        <div className="stat-card">
                            <div className="stat-value" style={{ color: '#E65100' }}>{stats.abiertos}</div>
                            <div className="stat-label">Abiertos</div>
                        </div>
                        <div className="stat-card">
                            <div className="stat-value" style={{ color: '#1565C0' }}>{stats.en_proceso}</div>
                            <div className="stat-label">En proceso</div>
                        </div>
                        <div className="stat-card">
                            <div className="stat-value" style={{ color: '#1E7E34' }}>{stats.completados}</div>
                            <div className="stat-label">Completados</div>
                        </div>
                    </div>

                    <div className="card">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                            <h2 style={{ margin: 0 }}>Expedientes recientes</h2>
                            <button className="btn btn-secondary btn-sm" onClick={() => navigate('/expedientes')}
                                title="Ver todos los expedientes y crear nuevos">
                                Ver todos
                            </button>
                        </div>
                        <table className="data-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Nombre</th>
                                    <th>Estado</th>
                                    <th>CR</th>
                                    <th>Fecha</th>
                                </tr>
                            </thead>
                            <tbody>
                                {stats.recientes.map(e => (
                                    <tr key={e.id} onClick={() => navigate(`/expedientes/${e.id}`)}
                                        style={{ cursor: 'pointer' }}>
                                        <td>#{e.id}</td>
                                        <td>{e.nombre}</td>
                                        <td><span className={`badge badge-${e.estado === 'abierto' ? 'open' : e.estado === 'en_proceso' ? 'progress' : 'done'}`}>{e.estado}</span></td>
                                        <td>{e.cr_id}</td>
                                        <td>{new Date(e.created_at).toLocaleDateString()}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </>
            )}

            {!stats && (
                <div className="card" style={{ textAlign: 'center', padding: '60px 20px' }}>
                    <h2 style={{ color: 'var(--color-text-muted)' }}>Bienvenido a Gestión Embargos N63</h2>
                    <p style={{ color: 'var(--color-text-muted)' }}>Crea un nuevo expediente para empezar</p>
                    <button className="btn btn-primary" onClick={() => navigate('/expedientes')}
                        title="Acceder a la lista completa de expedientes">
                        Ir a Expedientes
                    </button>
                </div>
            )}
        </div>
    );
}
